<template>
  <b-card no-body>
    <b-card-header>
      <b-card-title>{{ title }}</b-card-title>
    </b-card-header>
    <b-card-body>
      <smart-users-map :map-height="500" />
    </b-card-body>
  </b-card>
</template>

<script>
import SmartUsersMap from '@hw-ui/smart-components/maps/SmartUsersMap.vue'
import {
    BCard,
    BCardTitle,
    BCardHeader,
    BCardBody,
} from 'bootstrap-vue'


export default {
    components: {
        SmartUsersMap,
        BCard,
        BCardHeader,
        BCardBody,
        BCardTitle,
    },
    props: {
        title: {
            type: String,
            default: '',
        },
    }
}
</script>